<!-- 購入期限の注意書き -->
<template>
  <div class="warning-block">
    <div>
      {{ limit }} までに購入を完了してください。<br />
      期限を過ぎると自動で予約が取り消されます
    </div>
  </div>
</template>

<script>
export default {
  name: "StorePurchaseLimitCaution",
  props: {
    limit: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.warning-block {
  margin-top: 16px 6px 16px;
  font-size: 14px;
  text-align: center;
  line-height: 18px;
  color: #ed2323;
  font-weight: bold;
}
</style>
